module.exports = __webpack_public_path__ + "static/media/14-jan19jun19.2c536d3c.pdf";